import { IMaskInput } from 'react-imask'
import { type ReactElement } from 'react'
import { isNotDefined } from '@terros/common'
import { InputBase, type InputBaseProps } from '@mantine/core'
import { stripPhone } from '@front/model'

type Props = InputBaseProps & {
  value?: string
  onChange?: (value: string) => void
}
export const PhoneNumberInput = (props: Props): ReactElement => {
  return (
    <InputBase
      placeholder='(###) ###-####'
      {...props}
      type='tel'
      component={IMaskInput}
      mask='(000) 000-0000'
      onPaste={(event) => {
        if (isNotDefined(props.onChange)) return
        event.preventDefault()
        const text = event.clipboardData.getData('text')
        props.onChange(stripPhone(text))
      }}
      onChange={(event) => {
        if (isNotDefined(props.onChange)) return
        props.onChange(stripPhone(event.currentTarget.value))
      }}
    />
  )
}
